import React from 'react'

import { getCurrentAppData } from '../../utils/fractalApps'

const EditionImage = () => getCurrentAppData() ? (
  <a
    style={{
      display: 'flex',
      height: '15rem',
      justifyContent: 'center',
      width: '10rem'
    }}
    href={getCurrentAppData().redirectUrl} >
    <img
      style={{
        height: 'fit-content',
        margin: 'auto',
        maxWidth: '20em'
      }}
      src={getCurrentAppData().logo}
      alt={getCurrentAppData().name}
    />
  </a>
) : null

export default EditionImage
